import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import SkillOpportunityLogo from "../assets/images/SkillOpportunityLogo.png";
import { useTheme } from "@mui/material/styles";
import axios from "axios";

// Page name to path mapping
const pages = [
  { name: "Home", path: "/dashboard" },
  { name: "Events", path: "/events" },
  { name: "Coupons", path: "/coupons" },
];

const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleLogout = async () => {
    let sessionData = localStorage.getItem("SKILL_OP_SESSION");
    sessionData = JSON.parse(sessionData);
    const sessionId = sessionData.SESSION_ID;

    try {
      await axios.post("https://your-api.com/user/userLogout", {
        SESSION_ID: sessionId,
      });
    } catch (err) {
      console.error("Logout failed:", err);
      // optional: show a toast
    } finally {
      localStorage.clear(); // clear even if API fails
      navigate("/login");
    }
  };

  return (
    <AppBar position="static" sx={{ background: "#fff" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              onClick={handleOpenNavMenu}
              sx={{ color: theme.palette.text.primary }}
            >
              <MenuIcon />
            </IconButton>

            <Menu
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              sx={{
                display: { xs: "block", md: "none" },
                "& .MuiPaper-root": {
                  backgroundColor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.name}
                  onClick={() => {
                    handleCloseNavMenu();
                    navigate(page.path);
                  }}
                  selected={location.pathname === page.path}
                >
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
              <MenuItem
                onClick={() => {
                  handleCloseNavMenu();
                  localStorage.clear();
                  navigate("/");
                }}
              >
                <Typography textAlign="center" color="#d32f2f">
                  Logout
                </Typography>
              </MenuItem>
            </Menu>
          </Box>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            <img
              src={SkillOpportunityLogo}
              style={{
                width: 100,
                height: 65,
                objectFit: "contain",
              }}
              alt="logo"
            />
            <Typography
              variant="h6"
              noWrap
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontWeight: 700,
                letterSpacing: ".1rem",
                color: "#009d7c",
                textDecoration: "none",
              }}
            >
              Skill Opportunity
            </Typography>
          </div>

          {/* Mobile menu */}

          {/* Mobile logo */}
          <Typography
            variant="h6"
            noWrap
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              fontWeight: 700,
              color: "#009d7c",
              textDecoration: "none",
            }}
          >
            Skill Opportunity
          </Typography>

          {/* Desktop nav */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "right",
            }}
          >
            {pages.map((page) => (
              <Button
                key={page.name}
                onClick={() => navigate(page.path)}
                sx={{
                  mx: 1,
                  fontWeight: location.pathname === page.path ? 700 : 400,
                  borderBottom:
                    location.pathname === page.path
                      ? "2px solid #009d7c"
                      : "none",
                  color: location.pathname === page.path ? "#009d7c" : "black",
                  borderRadius: 0,
                }}
              >
                {page.name}
              </Button>
            ))}
            <Button
              onClick={() => {
                localStorage.clear();
                navigate("/");
              }}
              sx={{
                mx: 1,
                fontWeight: 500,
                color: "#d32f2f",
                border: "1px solid #d32f2f",
                borderRadius: "20px",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#fbe9e7",
                  borderColor: "#d32f2f",
                },
              }}
            >
              Logout
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
